import { QueryClient } from '@tanstack/react-query';

import { ONE_MINUTE } from '@/resources/time';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: ONE_MINUTE,
    },
  },
});

// Image queries cache an object URL created via URL.createObjectURL. The browser
// holds that blob in memory until the URL is revoked, so release it once the cache
// entry is evicted (no observers left) to avoid leaking blobs for the page lifetime.
queryClient.getQueryCache().subscribe((event) => {
  if (event.type !== 'removed' || event.query.queryKey[0] !== 'image') return;

  const data = event.query.state.data as { blobUrl?: string, } | undefined;

  if (data?.blobUrl) {
    URL.revokeObjectURL(data.blobUrl);
  }
});
